module.exports = __webpack_public_path__ + "img/79dda2b.jpg";